import { FormattedMessage } from "react-intl";
import { AlertBanner, Text } from "@lendcord/concord";
import type { JoinEnterpriseRequestStatus } from "@/app/profile/profile.types";

interface JoinEnterpriseStatusBannerProps {
  status: JoinEnterpriseRequestStatus | undefined;
  enterpriseName?: string | null;
  remarks?: string | null;
}

// Renders the post-request state for a BORROWER/LENDER who has already sent
// (or had decided) a join-enterprise request — mirrors
// UpgradeRequestStatusBanner's shape exactly, same allowJoinEnterprise-is-
// the-gate contract as that component's allowRequestForUpgradation.
export function JoinEnterpriseStatusBanner({ status, enterpriseName, remarks }: JoinEnterpriseStatusBannerProps) {
  switch (status) {
    case "APPROVED":
      return (
        <AlertBanner status="success" className="mt-4">
          <FormattedMessage
            id="lender.profile.joinEnterpriseApproved"
            values={{ enterprise: enterpriseName ?? "–" }}
          />
        </AlertBanner>
      );
    case "REJECTED":
      return (
        <AlertBanner status="warning" className="mt-4">
          <FormattedMessage
            id="lender.profile.joinEnterpriseRejected"
            values={{
              enterprise: enterpriseName ?? "–",
              remarks: remarks ?? <FormattedMessage id="lender.profile.joinEnterpriseRejectedNoRemarks" />,
            }}
          />
        </AlertBanner>
      );
    case "IN_PROGRESS":
      return (
        <AlertBanner status="info" className="mt-4">
          <FormattedMessage id="lender.profile.joinEnterpriseInProgress" values={{ enterprise: enterpriseName ?? "–" }} />
          {remarks && (
            <Text as="p" size="xs" variant="muted" className="mt-1">
              {remarks}
            </Text>
          )}
        </AlertBanner>
      );
    case "NOT_APPLIED":
    default:
      // Reachable when the caller has already moved off the default branch
      // some other way (e.g. agent onboarding) without ever applying — same
      // "nothing accurate to say" reasoning as UpgradeRequestStatusBanner.
      return null;
  }
}
